import {
  TableBody,
  TableRow,
  TableCell,
  CircularProgress,
} from "@mui/material";
import { EmptyTable } from "../../../modules/clients/components/EmptyState";
import { TableItem, TableRowType } from "./RopTable";

type RopTableRowProps = {
  hover?: boolean;
  itemsHeaders?: TableItem[];
  itemRows?: TableRowType[];
  itemFooter?: TableRowType;
  isLoading?: boolean;
};

export default function RopTableBody(props: RopTableRowProps) {
  return (
    <TableBody>
      {!props.isLoading ? (
        props.itemRows && props.itemRows.length > 0 ? (
          <>
            {props.itemRows?.map((row, i) => (
              <TableRow
                key={i}
                onClick={row.onClick}
                hover={props.hover}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  cursor: row.onClick ? "pointer" : "default",
                }}
              >
                {row.rowItems.map((e, i) => (
                  <TableCell
                    sx={{
                      display: {
                        xs: e.isMobile ? "table-cell" : "none",
                        md: "table-cell",
                      },
                      width: e.width
                    }}
                    key={i}
                    align={e.align}
                    component="th"
                    scope="row"
                  >
                    {e.item}
                  </TableCell>
                ))}
              </TableRow>
            ))}
            <TableRow
              onClick={props.itemFooter?.onClick}
              hover={props.hover}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                cursor: props.itemFooter?.onClick ? "pointer" : "default",
                backgroundColor: "#EE7D00",
              }}
            >
              {props.itemFooter?.rowItems.map((e, i) => (
                <TableCell
                  sx={{
                    display: {
                      xs: e.isMobile ? "table-cell" : "none",
                      md: "table-cell",
                    },
                  }}
                  key={i}
                  align={e.align}
                  component="th"
                  scope="row"
                >
                  {e.item}
                </TableCell>
              ))}
            </TableRow>
          </>
        ) : (
          <TableRow>
            <TableCell
              sx={{
                textAlign: "center",
                borderBottom: "none",
              }}
              colSpan={props.itemsHeaders?.length}
            >
              <EmptyTable />
            </TableCell>
          </TableRow>
        )
      ) : (
        <TableRow>
          <TableCell
            sx={{
              textAlign: "center",
              borderBottom: "none",
              height: "100px",
            }}
            colSpan={props.itemsHeaders?.length}
          >
            <CircularProgress />
          </TableCell>
        </TableRow>
      )}
    </TableBody>
  );
}
